// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:15:16

export default {
  "id": "huggy-mix-sprunki-music-box",
  "slug": "huggy-mix-sprunki-music-box",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/99f63b78d97c41f99f3322ca2347892c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/99f63b78d97c41f99f3322ca2347892c/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Huggy Mix Sprunki Music Box",
      "description": "Welcome to the wonderful world of Huggy Mix Sprunki Music Box. This music game is filled with energy and rhythm. Follow the beats, tap along to the music, and have fun with casual gameplay.You can choose three modes: health, ice, and bad man. You can make unique tunes that reflect your personality.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "health",
        "horror",
        "ice",
        "music"
      ]
    },
    "zh-CN": {
      "title": "温馨混音音乐盒",
      "description": "欢迎来到Huggy Mix Sprunki音乐盒的奇妙世界。这款音乐游戏充满了活力和节奏。跟随节拍，随着音乐轻点，享受轻松的游戏乐趣。你可以选择三种模式：健康、冰和坏人。你可以创作出反映你个性的独特旋律。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "健康",
        "恐怖",
        "冰",
        "音乐"
      ]
    },
    "zh-TW": {
      "title": "懷抱混音Sprunki音籌",
      "description": "歡迎進入 Huggy Mix Sprunki 音樂盒的奇妙世界。這是一款充滿活力與節奏的音樂遊戲。隨著節奏，隨著音樂敲擊，享受輕鬆的遊戲體驗。您可以選擇三種模式：健康、冰和壞人。您可以創造出反映您個性的獨特旋律。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "隨意"
      ],
      "tags": [
        "健康",
        "恐怖",
        "冰",
        "音樂"
      ]
    },
    "zh-HK": {
      "title": "親親混音蘋果音樂盒",
      "description": "歡迎進入奇妙的世界——Huggy Mix Sprunki 音樂盒。這是一款充滿活力與節奏的音樂遊戲。跟隨節奏，拍打節拍，享受輕鬆遊戲體驗。您可以選擇三種模式：健康、冰和壞人。您可以創造出反映您個性的獨特旋律。",
      "instructions": "滑鼠點擊或觸碰以遊玩",
      "genres": [
        "隨意"
      ],
      "tags": [
        "健康",
        "恐怖",
        "冰",
        "音樂"
      ]
    },
    "ja": {
      "title": "ハギー・ミックス・スプリンキー・ミュージックボックス",
      "description": "ようこそ、素晴らしいHuggy Mix Sprunki Music Boxの世界へ。この音楽ゲームはエネルギッシュでリズムに満ちています。ビートに合わせて音楽に合わせて、カジュアルなゲームプレイを楽しみましょう。三つのモードを選択できます：ヘルス、アイス、バッドマン。あなたの個性を反映したユニークな曲を作成できます。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "ヒールス",
        "ホラー",
        "アイス",
        "音楽"
      ]
    },
    "ko": {
      "title": "후기 미스스프빈키 뮤직박스",
      "description": "환영하세요, Huggy Mix Sprunki 음악 상자의奇妙한 세상으로. 이 음악 게임은 에너지와 리듬이 가득하다. 비트를 따라해, 음악에 맞춰 탭하고, 캐주얼 게임으로 즐겨보세요. 건강, 빙, 나쁜 사람 등 세 가지 모드를 선택할 수 있습니다. 여러분의 성격을 반영한 독특한 트윈을 만들 수 있습니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "건강",
        "공포",
        "빙하",
        "음악"
      ]
    },
    "fr": {
      "title": "Boîte à musique Huggy Mix Sprunki",
      "description": "Bienvenue dans le merveilleux monde de la Music Box Huggy Mix Sprunki. Ce jeu de musique est rempli d'énergie et de rythme. Suivez les beats, tapez en rythme avec la musique et amusez-vous avec une jouabilité casual. Vous pouvez choisir parmi trois modes : santé, glace et méchant. Vous pouvez créer des mélodies uniques qui reflètent votre personnalité.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Casual"
      ],
      "tags": [
        "santé",
        "horreur",
        "glace",
        "musique"
      ]
    }
  }
};
